import { render, staticRenderFns } from "./GroeiTip.vue?vue&type=template&id=6b46bd7c&"
import script from "./GroeiTip.vue?vue&type=script&lang=js&"
export * from "./GroeiTip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GroeiTip.vue"
export default component.exports